<template>
  <OfferButton
    ref="targetEl"
    :class="classes.offerButton"
    :buttonId="buttonId"
    :href="href"
    :text="buttonText"
    @click="handleClick"
  />
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import OfferButton from "../styled/OfferButton.vue";
import { defineComponent, computed } from "vue";
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { useAnalytics } from "../../hooks/useAnalytics";
import { useGetOffer } from "../../hooks/useDisplayOffer";

const useStyles = createUseStyles({
  offerButton: {
    display: "flex",
    fontSize: "14px",
    alignItems: "center"
  }
});

export default defineComponent({
  components: { OfferButton },
  props: {},
  setup() {
    const { brand, adTemplate } = injectBrand();
    const displayOffer = useGetOffer();
    const classes = useStyles();
    const { handleClick } = useAnalytics({}, "Offer Button");

    const { targetEl } = composePopoverForm("Offer Button", [
      {
        type: "button",
        get: () => brand.value.adTemplate.offer?.button,
        set: (value: string) => {
          if (!brand.value.adTemplate.offer) {
            brand.value.adTemplate.offer = {
              header: "",
              body: "",
              button: "",
              terms: ""
            };
          }

          brand.value.adTemplate.offer.button = value;
        }
      }
    ]);

    return {
      classes,
      handleClick,
      targetEl,
      href: computed(() => displayOffer.value && displayOffer.value?.link),
      buttonId: computed(() => adTemplate.value?.offer?.button),
      buttonText: computed(
        () => displayOffer.value && displayOffer.value?.buttonText
      )
    };
  }
});
</script>
